(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-pdf-quote"] && !Shopify.designMode) return;
  try {
    if (!window.customElements.get('pdf-quote')) {
    class PdfQuote extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.form = this.querySelector('form');
        this.formPanel = this.querySelector('[data-pdf-quote-form-panel]');
        this.successPanel = this.querySelector('[data-pdf-quote-success-panel]');
        this.trigger = this.querySelector('[data-pdf-quote-open]');
        this.submitButton = this.form.querySelector('[type="submit"]');

        this.trigger.addEventListener('click', () => this.open());
        this.querySelectorAll('[data-pdf-quote-close]').forEach((element) => {
          element.addEventListener('click', (event) => {
            event.preventDefault();
            this.close();
          });
        });
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.close();
        });
        this.form.addEventListener('submit', (event) => this.submit(event));
      }

      get productForm() {
        return document.getElementById(this.dataset.formId);
      }

      open() {
        this.formPanel.hidden = false;
        this.successPanel.hidden = true;
        this.clearErrors();

        // Start from the quantity already chosen on the page
        const pageQuantity = document.getElementById(this.dataset.formId + '-quantity');
        const quantityField = this.form.elements.quantity;
        const pageValue = pageQuantity ? parseInt(pageQuantity.value, 10) : NaN;
        if (pageValue >= parseInt(quantityField.min, 10) && pageValue <= parseInt(quantityField.max, 10)) {
          quantityField.value = pageValue;
        }

        this.openedAt = Date.now();

        if (typeof this.dialog.showModal === 'function') {
          this.dialog.showModal();
        } else {
          this.dialog.setAttribute('open', '');
        }

        this.form.elements.name.focus();
      }

      close() {
        if (typeof this.dialog.close === 'function') {
          this.dialog.close();
        } else {
          this.dialog.removeAttribute('open');
        }
        this.trigger.focus();
      }

      clearErrors() {
        this.querySelectorAll('.pdf-quote__field-error, .pdf-quote__form-error').forEach((element) => {
          element.hidden = true;
          element.textContent = '';
        });
        this.form.querySelectorAll('[aria-invalid]').forEach((field) => field.removeAttribute('aria-invalid'));
      }

      showError(message, field) {
        const target = field ? this.querySelector('[data-error-for="' + field + '"]') : null;
        const element = target || this.querySelector('.pdf-quote__form-error');
        element.textContent = message || this.dataset.errorGeneric;
        element.hidden = false;

        if (target && this.form.elements[field]) {
          this.form.elements[field].setAttribute('aria-invalid', 'true');
          this.form.elements[field].focus();
        }
      }

      validate() {
        const name = this.form.elements.name.value.trim();
        const email = this.form.elements.email.value.trim();
        const quantityField = this.form.elements.quantity;
        const quantity = parseInt(quantityField.value, 10);

        if (name.length < 2) return this.showError(this.dataset.errorName, 'name'), false;
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return this.showError(this.dataset.errorEmail, 'email'), false;
        if (isNaN(quantity) || quantity < parseInt(quantityField.min, 10) || quantity > parseInt(quantityField.max, 10)) {
          return this.showError(this.dataset.errorQuantity, 'quantity'), false;
        }

        return true;
      }

      submit(event) {
        event.preventDefault();
        this.clearErrors();
        if (!this.validate()) return;

        const productForm = this.productForm;
        const variantInput = productForm ? productForm.querySelector('[name="id"]') : null;
        const colourInput = document.querySelector(
          '[name="properties[Colour]"][form="' + this.dataset.formId + '"]:checked, #' + this.dataset.formId + ' [name="properties[Colour]"]:checked'
        );

        // Form-encoded, so the browser sends it as a simple cross-origin request
        const body = new URLSearchParams({
          name: this.form.elements.name.value.trim(),
          email: this.form.elements.email.value.trim(),
          quantity: this.form.elements.quantity.value,
          product_id: this.dataset.productId,
          variant_id: variantInput ? variantInput.value : '',
          colour: colourInput ? colourInput.value : '',
          website: this.form.elements.website.value,
          elapsed_ms: String(Date.now() - (this.openedAt || Date.now()))
        });

        const label = this.submitButton.innerHTML;
        this.submitButton.disabled = true;
        this.submitButton.setAttribute('aria-busy', 'true');
        this.submitButton.textContent = this.dataset.sending;

        fetch(this.dataset.endpoint, { method: 'POST', body: body })
          .then((response) => response.json().catch(() => ({ success: false })))
          .then((data) => {
            if (data.success) {
              this.querySelector('[data-pdf-quote-success-message]').textContent = data.message;
              this.formPanel.hidden = true;
              this.successPanel.hidden = false;
              this.form.reset();
            } else {
              this.showError(data.message, data.field);
            }
          })
          .catch(() => this.showError(this.dataset.errorGeneric))
          .finally(() => {
            this.submitButton.disabled = false;
            this.submitButton.removeAttribute('aria-busy');
            this.submitButton.innerHTML = label;
          });
      }
    }

    window.customElements.define('pdf-quote', PdfQuote);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wb-quick-setup"] && !Shopify.designMode) return;
  try {
    if (!window.customElements.get('wb-quick-setup')) {
    const ATTRIBUTE_KEYS = [
      'Recipient First Name',
      'Recipient Last Name',
      'Recipient Company',
      'Recipient Address 1',
      'Recipient Address 2',
      'Recipient City',
      'Recipient Postcode',
      'Recipient Country',
      'Recipient Postcard'
    ];

    // Same pattern SEPOS checks the order against
    const UK_POSTCODE = /^(GIR 0AA|[A-PR-UWYZ]([0-9]{1,2}|([A-HK-Y][0-9]([0-9ABEHMNPRV-Y])?)|[0-9][A-HJKPS-UW]) [0-9][ABD-HJLNP-UW-Z]{2})$/;

    const normalisePostcode = (value) => {
      const raw = (value || '').toUpperCase().replace(/\s+/g, '');
      return raw.length > 3 ? raw.slice(0, -3) + ' ' + raw.slice(-3) : raw;
    };

    class WbQuickSetup extends HTMLElement {
      connectedCallback() {
        this.state = this.dataset.state;
        this.dialog = this.querySelector('dialog');
        this.form = this.querySelector('form');
        this.onCheckoutClick = this.onCheckoutClick.bind(this);
        this.onDocumentSubmit = this.onDocumentSubmit.bind(this);
        this.onDocumentClick = this.onDocumentClick.bind(this);

        // Window capture runs before the Hulk Apps discount script, which takes over Checkout
        // clicks from a document-level handler and sends the customer to its own checkout
        window.addEventListener('click', this.onCheckoutClick, true);
        document.addEventListener('submit', this.onDocumentSubmit, true);
        document.addEventListener('click', this.onDocumentClick);

        // The cart no longer qualifies: forget what was saved so it can't reach the order
        if (this.state === 'stale-quick') this.save(this.emptyAttributes(), '').catch(() => {});
        if (this.state === 'stale-standard') this.save({ 'Setup Mode': '' }).catch(() => {});

        if (!this.dialog) return;

        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.close();
        });
        this.querySelectorAll('[data-quick-setup-close]').forEach((element) => element.addEventListener('click', () => this.close()));
        this.querySelector('[data-quick-setup-back]').addEventListener('click', () => this.show('choice'));
        this.querySelectorAll('[data-quick-setup-choose]').forEach((button) => {
          button.addEventListener('click', () => this.choose(button.dataset.quickSetupChoose, button));
        });
        this.form.addEventListener('submit', (event) => this.submitDetails(event));
        this.form.addEventListener('input', (event) => {
          if (event.target.name === 'note') {
            this.querySelector('[data-quick-setup-counter]').textContent = event.target.value.length + '/400';
          }
          this.clearError(event.target.name);
        });
      }

      disconnectedCallback() {
        window.removeEventListener('click', this.onCheckoutClick, true);
        document.removeEventListener('submit', this.onDocumentSubmit, true);
        document.removeEventListener('click', this.onDocumentClick);
      }

      get root() {
        return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      }

      emptyAttributes() {
        const attributes = { 'Setup Mode': '' };
        ATTRIBUTE_KEYS.forEach((key) => { attributes[key] = ''; });
        return attributes;
      }

      // Checkout clicked with one gift and nothing chosen yet: ask first
      onCheckoutClick(event) {
        if (this.state !== 'ask' || this.proceeding) return;
        const button = event.target.closest && event.target.closest('form.cart-form [name="checkout"]');
        if (!button) return;

        event.preventDefault();
        event.stopPropagation();
        this.checkoutForm = button.form;
        this.checkoutButton = button;
        this.open('choice');
      }

      // Backstop for a cart form submitted without a click
      onDocumentSubmit(event) {
        if (this.state !== 'ask' || this.proceeding) return;
        const form = event.target;
        if (!(form instanceof HTMLFormElement) || !form.classList.contains('cart-form')) return;
        if (event.submitter && event.submitter.name !== 'checkout') return;

        event.preventDefault();
        event.stopImmediatePropagation();
        this.checkoutForm = form;
        this.checkoutButton = event.submitter || form.querySelector('[name="checkout"]');
        this.open('choice');
      }

      // Links that sit outside this element: the saved-details card and the standard line
      onDocumentClick(event) {
        const opener = event.target.closest('[data-quick-setup-open]');
        if (opener && this.dialog) {
          event.preventDefault();
          this.open(opener.dataset.quickSetupOpen);
          return;
        }

        const action = event.target.closest('[data-quick-setup-action="standard"]');
        if (action) {
          event.preventDefault();
          action.disabled = true;
          this.save(Object.assign(this.emptyAttributes(), { 'Setup Mode': 'Standard' }), '')
            .then(() => window.location.reload())
            .catch(() => { action.disabled = false; });
        }
      }

      open(panel) {
        this.show(panel === 'details' ? 'details' : 'choice');
        if (typeof this.dialog.showModal === 'function') {
          if (!this.dialog.open) this.dialog.showModal();
        } else {
          this.dialog.setAttribute('open', '');
        }
      }

      close() {
        if (typeof this.dialog.close === 'function') {
          this.dialog.close();
        } else {
          this.dialog.removeAttribute('open');
        }
      }

      show(panel) {
        this.querySelectorAll('[data-quick-setup-panel]').forEach((element) => {
          element.hidden = element.dataset.quickSetupPanel !== panel;
        });
        this.dialog.scrollTop = 0;
        const focusTarget = panel === 'details' ? this.form.elements.first : this.querySelector('[data-quick-setup-choose="quick"]');
        if (focusTarget) focusTarget.focus();
      }

      choose(option, button) {
        if (option === 'quick') {
          this.show('details');
          return;
        }

        // From Checkout, carry on to checkout; from the "Change" link, just refresh the cart
        button.disabled = true;
        this.save(Object.assign(this.emptyAttributes(), { 'Setup Mode': 'Standard' }), '')
          .then(() => (this.checkoutForm ? this.proceed() : window.location.reload()))
          .catch(() => { button.disabled = false; });
      }

      clearError(name) {
        const error = this.querySelector('[data-error-for="' + name + '"]');
        if (error) {
          error.hidden = true;
          error.textContent = '';
        }
        if (this.form.elements[name]) this.form.elements[name].removeAttribute('aria-invalid');
        const formError = this.querySelector('[data-error-for="form"]');
        formError.hidden = true;
      }

      showError(name, message) {
        const error = this.querySelector('[data-error-for="' + name + '"]');
        error.textContent = message;
        error.hidden = false;
        if (this.form.elements[name]) this.form.elements[name].setAttribute('aria-invalid', 'true');
      }

      validate(values) {
        const errors = {};
        if (!values.first) errors.first = this.dataset.errorFirst;
        if (!values.last) errors.last = this.dataset.errorLast;
        if (values.address1.length < 2) errors.address1 = this.dataset.errorAddress1;
        if (values.city.length < 2) errors.city = this.dataset.errorCity;
        if (!UK_POSTCODE.test(values.postcode)) errors.postcode = this.dataset.errorPostcode;
        if (values.note.length > 400) errors.note = this.dataset.errorNote;
        return errors;
      }

      submitDetails(event) {
        event.preventDefault();
        const elements = this.form.elements;
        const values = {
          first: elements.first.value.trim(),
          last: elements.last.value.trim(),
          company: elements.company.value.trim(),
          address1: elements.address1.value.trim(),
          address2: elements.address2.value.trim(),
          city: elements.city.value.trim(),
          postcode: normalisePostcode(elements.postcode.value),
          note: elements.note.value.trim(),
          postcard: (elements.postcard && elements.postcard.value) || 'none'
        };

        ['first', 'last', 'address1', 'city', 'postcode', 'note'].forEach((name) => this.clearError(name));
        const errors = this.validate(values);
        const invalid = Object.keys(errors);
        if (invalid.length) {
          invalid.forEach((name) => this.showError(name, errors[name]));
          elements[invalid[0]].focus();
          return;
        }

        elements.postcode.value = values.postcode;

        const submitButton = this.form.querySelector('[type="submit"]');
        const label = submitButton.innerHTML;
        submitButton.disabled = true;
        submitButton.setAttribute('aria-busy', 'true');
        submitButton.textContent = this.dataset.saving;

        this.save({
          'Setup Mode': 'Quick',
          'Recipient First Name': values.first,
          'Recipient Last Name': values.last,
          'Recipient Company': values.company,
          'Recipient Address 1': values.address1,
          'Recipient Address 2': values.address2,
          'Recipient City': values.city,
          'Recipient Postcode': values.postcode,
          'Recipient Country': 'GB',
          'Recipient Postcard': values.postcard
        }, values.note)
          .then(() => this.proceed())
          .catch(() => {
            this.showError('form', this.dataset.errorGeneric);
            submitButton.disabled = false;
            submitButton.removeAttribute('aria-busy');
            submitButton.innerHTML = label;
          });
      }

      save(attributes, note) {
        const body = { attributes: attributes };
        if (typeof note === 'string') body.note = note;

        return fetch(this.root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        }).then((response) => {
          if (!response.ok) throw new Error('cart update failed');
          return response.json();
        });
      }

      // Carry on to checkout by clicking the real button again, so the discount app's own
      // checkout handling (volume pricing) still runs exactly as it does without quick setup
      proceed() {
        this.proceeding = true;
        const form = this.checkoutForm || document.querySelector('form.cart-form');
        const button = this.checkoutButton || (form && form.querySelector('[name="checkout"]'));

        this.close();
        if (button) {
          button.click();
        } else {
          window.location.href = this.root + 'checkout';
        }
      }
    }

    window.customElements.define('wb-quick-setup', WbQuickSetup);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wellbox-scroll-reveal"] && !Shopify.designMode) return;
  try {
    (function() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    function initReveal() {
      var els = document.querySelectorAll('[data-wellbox-reveal]');
      if (!els.length) return;

      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -60px 0px' });

      els.forEach(function(el) {
        observer.observe(el);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initReveal);
    } else {
      requestAnimationFrame(initReveal);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
